import React, { useRef } from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';
import Avatar from '@atlaskit/avatar';
import AvatarItem from '@atlaskit/avatar/AvatarItem';
import Button from '@atlaskit/button';
import PeopleIcon from '@atlaskit/icon/core/migration/people-group--people';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, Inline, xcss } from '@atlaskit/primitives';
import { N500 } from '@atlaskit/theme/colors';
import Tooltip from '@atlaskit/tooltip';
import { FormSupportedPrincipalType } from '../../../types';
import { messages } from './messages';
export const PrincipalItem = ({
  principal,
  canAccess,
  isDisabled,
  isViewMode,
  removePrincipal
}) => {
  const {
    formatMessage
  } = useIntl();
  const principalRef = useRef(null);
  const avatar = /*#__PURE__*/React.createElement(AvatarItem, {
    avatar: principal.type === FormSupportedPrincipalType.USER ? /*#__PURE__*/React.createElement(Avatar, {
      size: "medium",
      name: principal.name,
      src: principal.avatar
    }) : /*#__PURE__*/React.createElement(Box, {
      xcss: peopleIconStyles
    }, /*#__PURE__*/React.createElement(PeopleIcon, {
      LEGACY_size: "medium",
      spacing: "spacious",
      label: "",
      color: `var(--ds-icon, ${N500})`
    })),
    primaryText: /*#__PURE__*/React.createElement(Tooltip, {
      content: principal.name,
      ignoreTooltipPointerEvents: true,
      isScreenReaderAnnouncementDisabled: true,
      canAppear: () => {
        const principalElement = principalRef.current;
        return principalElement !== null && principalElement.scrollWidth > principalElement.clientWidth;
      }
    }, /*#__PURE__*/React.createElement(Box, {
      xcss: truncationStyles,
      ref: principalRef,
      testId: "proforma-form-security.common.ui.principal-list.principal-item"
    }, principal.name))
  });
  return /*#__PURE__*/React.createElement(Inline, null, /*#__PURE__*/React.createElement(Box, {
    xcss: avatarStyles
  }, avatar), /*#__PURE__*/React.createElement(Box, {
    xcss: permissionsStyles
  }, canAccess ? /*#__PURE__*/React.createElement(FormattedMessage, messages.hasAccess) : /*#__PURE__*/React.createElement(FormattedMessage, messages.noAccess)), !isViewMode && /*#__PURE__*/React.createElement(Box, {
    xcss: removeButtonStyles
  }, !isDisabled && /*#__PURE__*/React.createElement(Button, {
    appearance: "link",
    spacing: "none",
    onClick: () => removePrincipal(principal.ari),
    "aria-label": fg('granular_permissions_on_forms_ga') ? formatMessage(messages.removeLabel, {
      principalName: principal.name
    }) : ''
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.remove))));
};
const avatarStyles = xcss({
  width: '65%',
  margin: 'auto'
});
const peopleIconStyles = xcss({
  backgroundColor: 'color.background.accent.gray.subtlest',
  borderRadius: 'border.radius.circle',
  margin: 'space.025',
  padding: 'space.050'
});
const permissionsStyles = xcss({
  width: '23%',
  margin: 'auto'
});
const removeButtonStyles = xcss({
  width: '12%',
  margin: 'auto'
});
const truncationStyles = xcss({
  overflowX: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
});